module.exports = __webpack_public_path__ + "img/authorization.e40f2ea6.png";